import { render, staticRenderFns } from "./vsTab.vue?vue&type=template&id=77cdd419&lang=html"
import script from "./vsTab.vue?vue&type=script&lang=js"
export * from "./vsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports